// Routes du patrimoine (M10) et des équipements publics (M19), lot L4-A, raccordées dans Application.tsx
// par une seule ligne. Les chemins fixes précèdent les fiches.
import type { RouteObject } from 'react-router';
import { routesEquipements } from '../equipements/routes';
import { PageBien } from './PageBien';
import { PageInventaire } from './PageInventaire';
import { PageInventairePeriodique, PageInventaires } from './PageInventaires';
import { PageSorties } from './PageSorties';

export const routesPatrimoine: RouteObject[] = [
  { path: '/patrimoine', element: <PageInventaire /> },
  { path: '/patrimoine/inventaires', element: <PageInventaires /> },
  { path: '/patrimoine/inventaires/:id', element: <PageInventairePeriodique /> },
  { path: '/patrimoine/sorties', element: <PageSorties /> },
  { path: '/patrimoine/biens/:id', element: <PageBien /> },
  ...routesEquipements,
];
